import { Modal, Pill as BluBlocksPill } from "@bluframe/blublocks"
import Button from "components/buttons/Button"
import ConfirmModal from "components/ConfirmModal"
import Image from "components/Image"

import { ComponentProps } from "."
import {
  Buttons,
  Label,
  Left,
  Main,
  StatusGroup,
  SubtitlePrimary,
  Subtitles,
  SubtitleSecondary,
  Text,
  Wrapper
} from "./styled"

const Item = ({
  expandedItem,
  image,
  isAdmin,
  isExpanded,
  isModalOpen,
  isShowDelete,
  isShowView,
  label,
  statusPills,
  subtitlePrimary,
  subtitleSecondary,
  onModalClose,
  onModalConfirm,
  onModalOpen,
  onView
}: ComponentProps) => (
  <Wrapper>
    <Main>
      <Left $hasImage={Boolean(image)}>
        {image ? <Image {...image} /> : null}

        <Text>
          <Label>{label}</Label>

          {subtitlePrimary || subtitleSecondary ? (
            <Subtitles>
              {subtitlePrimary ? (
                <SubtitlePrimary>{subtitlePrimary}</SubtitlePrimary>
              ) : null}

              {subtitleSecondary ? (
                <SubtitleSecondary>{subtitleSecondary}</SubtitleSecondary>
              ) : null}
            </Subtitles>
          ) : null}

          {statusPills?.length ? (
            <StatusGroup aria-label="Item metadata">
              {statusPills.map(
                ({ ariaLabel, id, label: pillLabel, onClick, tone }) => {
                  const computedAriaLabel = ariaLabel ?? pillLabel

                  return (
                    <BluBlocksPill
                      ariaLabel={computedAriaLabel}
                      key={id}
                      label={pillLabel}
                      onClick={onClick}
                      tone={tone}
                    />
                  )
                }
              )}
            </StatusGroup>
          ) : null}
        </Text>
      </Left>

      <Buttons>
        {isShowDelete && isAdmin ? (
          <Button label="Delete" onClick={onModalOpen} outlined />
        ) : null}

        {isShowView ? <Button label="View" onClick={onView} /> : null}
      </Buttons>
    </Main>

    {isExpanded ? expandedItem : null}

    <Modal isOpen={isModalOpen} onClose={onModalClose}>
      <ConfirmModal
        message={`Are you sure you want to delete ${label}?`}
        onClose={onModalClose}
        onConfirm={onModalConfirm}
      />
    </Modal>
  </Wrapper>
)

export default Item
